export default function ProcessSection() {
  const processes = [
    {
      number: 1,
      title: 'Определение проектных деталей и анализ рисков',
      description: 'Фундамент успешного проекта — это тщательное планирование',
      items: [
        'Разработка технико-экономического обоснования и оценка рисков',
        'Создание эскиза и предварительного проекта (концепция и внешний вид)',
        'Геологическое обследование почвы и анализ участка',
        'Разработка инженерных сетей (электрика, механика) и ландшафта',
        'Бюрократия под ключ: Утверждение в профессиональных палатах, получение разрешений в муниципалитете, открытие трудовых книжек и оформление страхования ответственности'
      ]
    },
    {
      number: 2,
      title: 'Черновое строительство (Rough Construction)',
      description: 'Создание «скелета» здания с соблюдением правил охраны труда',
      items: [
        'Земляные работы (выемка грунта) и подготовка дренажной системы',
        'Гидроизоляция фундамента (профессиональная защита от износа и трещин согласно нормам)',
        'Монтаж арматуры, опалубки и заливка фундамента бетоном',
        'Возведение несущей системы: колонны, перекрытия, фасадные стены',
        'Теплоизоляция крыши и фасада для защиты от внешних факторов'
      ]
    },
    {
      number: 3,
      title: 'Чистовая отделка (Fine Works)',
      description: 'Превращение бетонной конструкции в эстетичный объект',
      items: [
        'Заливка бетонной стяжки (мелкозернистый бетон) для выравнивания поверхностей',
        'Монтаж инженерных систем: электропроводка, трубы, отопление/охлаждение',
        'Внутренние работы: штукатурка, гипсокартон, покраска, напольные покрытия',
        'Установка подвесных потолков, межкомнатных дверей и финишного оборудования',
        'Финальное тестирование всех механических и электрических систем'
      ]
    },
    {
      number: 4,
      title: 'Благоустройство территории (Site Arrangement)',
      description: 'После завершения черновых и отделочных работ мы приступаем к оформлению внешнего участка',
      items: [
        'Инфраструктура: Строительство подъездных дорог, парковочных зон и пешеходных дорожек вокруг здания',
        'Укрепление грунта: Создание «контролируемой насыпи» для уплотнения почвы и поддержки инфраструктурных систем',
        'Дренаж: Установка систем отвода воды для предотвращения эрозии и скопления влаги',
        'Организация зеленой зоны, обеспечение структурной целостности участка и подготовка объекта к финальной инспекции и передаче заказчику'
      ]
    }
  ];

  return (
    <section id="process" className="bg-[#2B2D42] py-40">
      <div className="max-w-6xl mx-auto px-8">
        {/* Section Header */}
        <div className="flex items-center gap-6 mb-24">
          <div className="w-1 h-20 bg-[#D4745E]"></div>
          <h2 className="text-5xl font-bold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
            Этапы реализации проекта
          </h2>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical Line */}
          <div className="absolute left-7 top-0 bottom-0 w-0.5 border-l-2 border-dashed border-gray-600"></div>

          {/* Process Steps */}
          <div className="space-y-16">
            {processes.map((process, index) => (
              <div key={index} className="relative flex items-start gap-8">
                {/* Number Circle */}
                <div className="relative z-10 flex-shrink-0">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#D4745E] to-[#E89580] flex items-center justify-center shadow-lg">
                    <span className="text-2xl font-bold text-white" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                      {process.number}
                    </span>
                  </div>
                </div>

                {/* Content Card */}
                <div className="flex-1 bg-white/5 backdrop-blur-md rounded-2xl p-10 border-l-4 border-[#D4745E] hover:bg-white/10 transition-all duration-300">
                  <h3 className="text-3xl font-bold text-white mb-5" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {process.title}
                  </h3>
                  <p className="text-base text-gray-300 leading-relaxed mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    {process.description}
                  </p>
                  <ul className="space-y-3">
                    {process.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <div className="w-1.5 h-1.5 bg-[#D4745E] rounded-sm mt-2 flex-shrink-0"></div>
                        <span className="text-sm text-gray-200 leading-relaxed" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
